// Redux
import {combineReducers} from 'redux'

// Modules
import app from './app'
import accounts from './accounts';

const appReducer = combineReducers({
    app,
    // auth,
    accounts,
})  


const rootReducer = (state, action) => {
    if (action.type === 'DESTROY') {
        state = undefined
    }

    return appReducer(state, action)
}

export default rootReducer
